import React from "react";
import { Facebook, Instagram, Youtube } from "lucide-react";

const Footer = () => (
  <footer data-testid="footer" className="bg-emerald_deep text-bone py-16 relative noise-overlay overflow-hidden">
    {/* Right side HD food border */}
    <div className="absolute right-0 top-0 bottom-0 w-[240px] hidden xl:block pointer-events-none">
      <img src="https://images.unsplash.com/photo-1498837167922-ddd27525d352?auto=format&fit=crop&w=500&h=800&q=80" alt="" className="w-full h-full object-cover opacity-[0.06]" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-l from-transparent to-[#0A1A14]" />
    </div>
    <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
        <div className="md:col-span-2">
          <div className="font-serif text-3xl mb-4"><span className="text-accent">Fitly</span> India</div>
          <p className="text-bone/60 leading-relaxed max-w-sm">
            World-class fertility nutrition and hormonal wellness. Helping families achieve their dreams through science-backed nutrition.
          </p>
          <div className="flex gap-4 mt-6">
            {[
              [Facebook, "https://www.facebook.com/294056110466070"],
              [Instagram, "https://www.instagram.com/fitly_india"],
              [Youtube, "https://www.youtube.com/fitly_india"]
            ].map(([Icon, href]) => (
              <a key={href} href={href} target="_blank" rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-bone/10 flex items-center justify-center hover:bg-accent/20 transition-colors">
                <Icon size={16} className="text-bone/70" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] uppercase font-semibold text-accent mb-4">Quick Links</h4>
          <ul className="space-y-2">
            {['Services', 'Programs', 'Team', 'Testimonials', 'Contact', 'FAQ'].map(item => (
              <li key={item}><a href={`#${item.toLowerCase()}`} className="text-bone/60 hover:text-accent transition-colors text-sm">{item}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] uppercase font-semibold text-accent mb-4">Contact</h4>
          <ul className="space-y-2 text-sm text-bone/60">
            <li><a href="tel:+919108818369" className="hover:text-accent transition-colors">+91 91088 18369</a></li>
            <li><a href="mailto:fitlyindiahealth@gmail.com" className="hover:text-accent transition-colors">fitlyindiahealth@gmail.com</a></li>
            <li>Mon - Sat, 10 AM - 6 PM</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-bone/10 pt-8 text-center text-bone/40 text-xs">
        &copy; {new Date().getFullYear()} Fitly India. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
